import { useState, useEffect, useContext } from "react";
import Chart from "../componentsTools/Chart.jsx";
import ChartPie from "../componentsTools/ChartPie.jsx";
import { DataContext } from "../../context/DataContext.jsx";
import { toast } from "sonner";
import { petitions } from "../../api/calls.js";

export default function Home() {
  const { session, idEmpresa } = useContext(DataContext);
  const [resumenTotales, setResumenTotales] = useState({});
  const [ventas7Dias, setVentas7Dias] = useState({});
  const [movMesActual, setMovMesActual] = useState({});
  const [movMesPasado, setMovMesPasado] = useState({});
  const [productosTop, setProductosTop] = useState([]);

  const mesActual = new Date().toLocaleString("es-ES", { month: "long" });

  useEffect(() => {
    const call = async () => {
      const response = await petitions.getTotalesResumen(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        setResumenTotales(response.data ?? {});
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    call();
  }, [idEmpresa, session]);

  useEffect(() => {
    const call = async () => {
      const response = await petitions.getVentas7dias(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        setVentas7Dias(response.data ?? {});
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    call();
  }, [idEmpresa, session]);

  useEffect(() => {
    const call = async () => {
      const response = await petitions.getMovTotalesMesActual(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        setMovMesActual(response.data ?? {});
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    call();
  }, [idEmpresa, session]);

  useEffect(() => {
    const call = async () => {
      const response = await petitions.getTotalComprasVentasMesPasado(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        setMovMesPasado(response.data ?? {});
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    call();
  }, [idEmpresa, session]);

  useEffect(() => {
    const call = async () => {
      const response = await petitions.getProductosMasVendidos(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        setProductosTop(response.data ?? []);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    call();
  }, [idEmpresa, session]);

  return (
    <>
      <div className="row gy-3 mb-6 justify-content-between">
        <div className="col-md-9 col-auto">
          <h2 className="mb-2 text-body-emphasis">
            Bienvenido a <strong className="text-primary">SignalR</strong>
          </h2>
          <h5 className="text-body-tertiary fw-semibold">
            Esto es lo que está pasando en tu empresa ahora mismo
          </h5>
        </div>
      </div>
      <div className="row mb-3 gy-6 mb-4">
        <div className="col-12">
          <div className="row align-items-center g-3 h-100">
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
              <div className="d-flex align-items-center">
                <span className="fs-4 lh-1 uil uil-box text-primary-dark"></span>
                <div className="ms-2">
                  <div className="d-flex align-items-end">
                    <h2 className="mb-0 me-2">
                      {resumenTotales?.totalProducts ?? 0}
                    </h2>
                    <span className="fs-7 fw-semibold text-body">
                      Productos
                    </span>
                  </div>
                  <p className="text-body-secondary fs-9 mb-0">Operativos</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
              <div className="d-flex align-items-center">
                <span className="fs-4 lh-1 uil uil-users-alt text-success-dark"></span>
                <div className="ms-2">
                  <div className="d-flex align-items-end">
                    <h2 className="mb-0 me-2">
                      {resumenTotales?.totalClients ?? 0}
                    </h2>
                    <span className="fs-7 fw-semibold text-body">Clientes</span>
                  </div>
                  <p className="text-body-secondary fs-9 mb-0">
                    Registrados / activos
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
              <div className="d-flex align-items-center">
                <span className="fs-4 lh-1 uil uil-invoice text-warning-dark"></span>
                <div className="ms-2">
                  <div className="d-flex align-items-end">
                    <h2 className="mb-0 me-2">
                      {resumenTotales?.totalVentas ?? 0}
                    </h2>
                    <span className="fs-7 fw-semibold text-body">Ventas</span>
                  </div>
                  <p className="text-body-secondary fs-9 mb-0">
                    Realizadas / pendientes
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
              <div className="d-flex align-items-center">
                <span className="fs-4 lh-1 uil uil-credit-card-search text-danger-dark"></span>
                <div className="ms-2">
                  <div className="d-flex align-items-end">
                    <h2 className="mb-0 me-2">
                      {resumenTotales?.totalCompras ?? 0}
                    </h2>
                    <span className="fs-7 fw-semibold text-body">Compras</span>
                  </div>
                  <p className="text-body-secondary fs-9 mb-0">En almacen</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-6 mb-5">
          <div className="card h-100 rounded-5 border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="mb-1">Total ventas</h5>
                  <h6 className="text-body-tertiary">Últimos 7 días</h6>
                </div>
              </div>
              <div className="d-flex justify-content-center px-4 py-6">
                <Chart theme="light" data={ventas7Dias} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-xl-6 mb-5">
          <div className="card h-100 rounded-5 border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="mb-1">Movimientos totales </h5>
                  <h6 className="text-body-tertiary">
                    Del mes de{" "}
                    <b>
                      {mesActual.charAt(0).toUpperCase() + mesActual.slice(1)}
                    </b>
                  </h6>
                </div>
              </div>
              <div className="d-flex justify-content-center px-4 py-6">
                <ChartPie theme="light" data={movMesActual} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-3 mb-3">
        <div className="col-sm-6 col-md-4 col-xl-3 col-xxl-4">
          <div className="card h-100 rounded-5 border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex d-sm-block justify-content-between">
                <div className="border-bottom-sm border-translucent mb-sm-4">
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex align-items-center icon-wrapper-sm shadow-primary-100"
                      style={{ transform: "rotate(-7.45deg)" }}
                    >
                      <span className="fa-solid fas fa-clipboard-check text-primary fs-7 z-1 ms-2"></span>
                    </div>
                    <p className="text-body-tertiary fs-9 mb-0 ms-2 mt-3">
                      Ventas
                    </p>
                  </div>
                  <p className="text-primary mt-2 fs-6 fw-bold mb-0 mb-sm-4">
                    {movMesPasado?.ventasEsteMes ?? 0} <span className="fs-8 text-body lh-lg">En este mes</span>
                  </p>
                </div>
                <div className="d-flex flex-column justify-content-center flex-between-end d-sm-block text-end text-sm-start">
                  <span className="badge badge-phoenix badge-phoenix-info fs-10 mb-2 rounded-5">
                    {movMesPasado?.ventasVariacionPct?.toFixed(2) ?? 0}%
                  </span>
                  <p className="mb-0 fs-9 text-body-tertiary">
                    Que el mes pasado
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-4 col-xl-3 col-xxl-4">
          <div className="card h-100 rounded-5 border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex d-sm-block justify-content-between">
                <div className="border-bottom-sm border-translucent mb-sm-4">
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex align-items-center icon-wrapper-sm shadow-info-100"
                      style={{ transform: "rotate(-7.45deg)" }}
                    >
                      <span className="fa-solid fas fa-toolbox text-info fs-7 z-1 ms-2"></span>
                    </div>
                    <p className="text-body-tertiary fs-9 mb-0 ms-2 mt-3">
                      Compras
                    </p>
                  </div>
                  <p className="text-info mt-2 fs-6 fw-bold mb-0 mb-sm-4">
                    {movMesPasado?.comprasEsteMes ?? 0} <span className="fs-8 text-body lh-lg">En este mes</span>
                  </p>
                </div>
                <div className="d-flex flex-column justify-content-center flex-between-end d-sm-block text-end text-sm-start">
                  <span className="badge badge-phoenix badge-phoenix-info fs-10 mb-2 rounded-5">
                    {movMesPasado?.comprasVariacionPct?.toFixed(2) ?? 0}%
                  </span>
                  <p className="mb-0 fs-9 text-body-tertiary">
                    Que el mes pasado
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-xl-6 col-xxl-4 gy-5 gy-md-3">
          <div className="border-bottom border-translucent">
            <h5 className="pb-4 border-bottom border-translucent">
              Top 5 productos mas vendidos
            </h5>
            <ul className="list-group list-group-flush">
              {
                productosTop.length > 0 ? (
                  productosTop.map((prod, index) => (
                    <li
                      key={index}
                      className="list-group-item bg-transparent list-group-crm fw-bold text-body fs-9 py-2"
                    >
                      <div className="d-flex justify-content-between">
                        <span className="fw-normal fs-9 mx-1">
                          {" "}
                          <span className="fw-bold">{index + 1}. </span>
                          {prod.nombre}{" "}
                        </span>
                        <span>({prod.totalCant})</span>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="list-group-item bg-transparent list-group-crm fw-bold text-body fs-9 py-2">
                    <div className="d-flex justify-content-between">
                      <span className="fw-normal fs-9 mx-1">
                        {" "}
                        <span className="fw-bold">1. </span>None{" "}
                      </span>
                      <span>(0)</span>
                    </div>
                  </li>
                )
              }              
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
